<div *ngIf="(isDesktop$ | async)" class="page-header">
    <div class="logo">
        <a class="round profile-photo"><i class="{{icon}}"></i></a>
    </div>
    <div class="header-info">
        <div>{{title}}</div>
        <div>{{description}}</div>
    </div>
</div>
